<template lang="pug">
  Default
    header.content__header
      button.content__menu-open(
        type='button'
        @click='showSidebar'
      )
      h1.content__title {{ title }}
      .content__header-search(
        v-click-outside='hideSearchField'
      )
        .content__search-field(
          v-if='searchFieldActive'
        )
          SearchField
        button.content__search-toggle(
          @click='toggleSearchField'
          :class='{ "is-active": searchFieldActive }'
        ) 
          Icon(
            :name='searchFieldActive ? "close" : "search"'
        )
    .content__body
      .content__item
        RawContent(
          :content="content"
        )

</template>

<script>
import PageLoader from "@/services/pageLoader";
import SearchField from "@/components/SearchField/SearchField";
import Icon from "@/components/Icon/Icon";
import showSearchField from "@/mixins/shared/showSearchField.mixin";
import defaultPage from "@/mixins/pages/default.mixin";
import showSidebar from "@/mixins/shared/showSidebar.mixin";
import errorHandler from "@/services/errorHandler";
import RawContent from "@/components/RawContent/RawContent";

const strategy = async function(route, ctx) {
  try {
    const { name } = route;
    const { content, id, title } = await PageLoader.getStaticPageData({ name });

    ctx.id = id;
    ctx.title = title;
    ctx.content = content;

    route.meta.title = title;
  } catch (error) {
    errorHandler.resolve(error);
  }
};

export default {
  name: "Page",
  data() {
    return {
      id: null,
      title: null,
      content: null
    };
  },
  mixins: [defaultPage(strategy), showSidebar, showSearchField],
  components: {
    RawContent,
    Icon,
    SearchField
  }
};
</script>
